module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7884/js/img/ServiceHub_Icon.svg"